module.exports = __webpack_public_path__ + "static/icons/icon-snowing--color-8461227b32c47c1b1ab699dbb6ca09da.svg";